module.exports = __webpack_public_path__ + "static/lights2-2b699823883e2e1a7369406ebce80aab.jpg";